import React from 'react';
import cx from 'classnames';

import { ButtonModal, EditorTabList } from 'spindl-shared-components';

import HTMLEditor from '../../organisms/HTMLEditor';
import Preview from '../../organisms/Preview';
import TemplateEditorSubNav from '../../organisms/TemplateEditorSubNav';

import styles from './TemplateEditorPage.module.scss';
import usePresenter from './TemplateEditorPage.presenter';
import getProps from './TemplateEditorPage.props';
import { TemplateEditorPageCombinedProps } from './types';
import TagsSideBar from '../../organisms/TagsSideBar';
import SettingsSideBar from '../../organisms/SettingsSideBar';

const TemplateEditorPage: React.FC<TemplateEditorPageCombinedProps> = (props) => {
  const {
    className,
    classes,
    templateEditorSubNav,
    editorTabList,
    hTMLEditor,
    preview,
    inputFile,
    handleFileChanges,
    warningModal,
    exitModal,
    currentView,
    leftPanel,
    tagsSideBar,
    settingsSideBar,
    closeSettingsSideBarModal,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.templateEditorPage;

  let leftPanelView;

  switch (leftPanel) {
    case 'Collapsed':
      break;
    case 'Tags':
      leftPanelView = (
        <TagsSideBar
          {...tagsSideBar}
          className={styles.leftPanelView}
        />
      );
      break;
    case 'Settings':
      leftPanelView = (
        <SettingsSideBar
          {...settingsSideBar}
          className={styles.leftPanelView}
        />
      );
      break;
  }

  return (
    <div className={cx(currentStyle, className)}>
      <ButtonModal 
        className={styles.modalWrapper}
        {...internalProps.warningModal}
        {...warningModal}
      />
      <ButtonModal
        className={styles.modalWrapper}
        {...internalProps.exitModal}
        {...exitModal}
      />
      <ButtonModal
        className={styles.modalWrapper}
        {...internalProps.closeSettingsSideBarModal}
        {...closeSettingsSideBarModal}
      />
      <TemplateEditorSubNav
        className={cx(styles.templateEditorSubNav, classes?.templateEditorSubNav)}
        {...internalProps.templateEditorSubNav}
        {...templateEditorSubNav}
      />
      <div className={cx(styles.editorContent, classes?.editorContent)}>
        <EditorTabList
          className={cx(styles.editorTabList, classes?.editorTabList)}
          {...internalProps.editorTabList}
          {...editorTabList}
        />

        {/* Left panel view (tags or settings sidebar) */}
        {leftPanelView}

        <HTMLEditor
          className={cx(
            currentView === 'Preview' ? styles.hideView : styles.hTMLEditor,
            leftPanel === 'Collapsed' ? null : styles.previewNoShrink,
            classes?.hTMLEditor,
          )}
          {...internalProps.hTMLEditor}
          {...hTMLEditor}
        />
        <Preview
          className={cx(
            currentView === 'Code view' ? styles.hideView : styles.preview,
            leftPanel === 'Collapsed' ? null : styles.hTMLEditorNoShrink,
            classes?.preview,
          )}
          {...internalProps.preview}
          {...preview}
        />
      </div>

      {/* For HTML file imports */}
      <input
        type='file'
        ref={inputFile}
        style={{ display: 'none' }}
        onChange={handleFileChanges}
        accept='.html'
      />
    </div>
  );
};

export default TemplateEditorPage;
